type NullableHTMLElement = HTMLElement | null;

interface ISetGratuity {
  (value: boolean): void;
}

function initGratuityDropdown(setGratuity: ISetGratuity) {
  document
    .querySelectorAll<HTMLElement>('.dropdown-radio input[type=radio]')
    .forEach((inputElement: HTMLElement) => {
      inputElement.addEventListener('click', function () {
        const dropdownElement: NullableHTMLElement =
          this.closest('.widget-dropdown');
        const radioName: string | null = this.getAttribute('name');

        if (!dropdownElement || !radioName) {
          return;
        }

        const radioElement: HTMLInputElement | null =
          dropdownElement?.querySelector(`input[name=${radioName}]:checked`) ??
          null;

        const radioCheckedText: string | null =
          radioElement?.nextElementSibling?.textContent ?? null;

        const buttonSpanElement: NullableHTMLElement =
          dropdownElement?.querySelector('.dd-button span') ?? null;

        if (buttonSpanElement && radioCheckedText) {
          buttonSpanElement.textContent = radioCheckedText;
        }

        document
          .querySelectorAll<HTMLInputElement>('.dd-toggle')
          .forEach((toggleElement: HTMLInputElement) => {
            toggleElement.checked = false;
          });

        if (radioElement && radioElement.value === 'gratuity') {
          setGratuity(true);
          return;
        }

        setGratuity(false);
      });
    });
}

function handleGratuityError(setGratuity: ISetGratuity) {
  document
    .querySelectorAll('input[name=switch-date-selection]')
    .forEach((inputElement: Element) => {
      inputElement.addEventListener('click', function (this: HTMLElement) {
        const value = this.getAttribute('value');
        const errorElement: HTMLInputElement | null = document.querySelector(
          '.widget-gratuity-error'
        );
        const dropdownElement: HTMLInputElement | null =
          document.querySelector('.widget-dropdown');

        const buttonSpanElement: NullableHTMLElement =
          dropdownElement?.querySelector('.dd-button span') ?? null;

        if (!value || !errorElement || !dropdownElement || !buttonSpanElement) {
          return;
        }

        if (value === 'ida-e-volta') {
          errorElement.classList.add('show');
          dropdownElement.classList.add('disabled');
          buttonSpanElement.textContent = 'Passagem comum';
          setGratuity(false);
          return;
        }

        errorElement.classList.remove('show');
        dropdownElement.classList.remove('disabled');
      });
    });
}

function createGratuityDropdown(form: HTMLFormElement) {
  const setGratuity: ISetGratuity = (value) =>
    form.setAttribute('data-gratuity', value ? '1' : '0');

  setGratuity(false);

  initGratuityDropdown(setGratuity);
  handleGratuityError(setGratuity);
}

export default createGratuityDropdown;
